import React, { Component, createRef } from "react";
import FavAction from "../FavoritesComp/FavAction";
import Slider from "react-slick";

export class SearchPageComp extends Component {
  constructor(props) {
    super(props);

    this.refx = this.props.listing.reduce((acc, value) => {
      acc[value.id] = createRef();
      return acc;
    }, {});
  }

  componentDidMount() {
    let pageSet = 1;
    if (!this.props.map && window.innerWidth > 767) {
      let _this = this;
      var listElm = document.querySelector("#search_result");
      listElm.addEventListener("scroll", function() {
        if (
          listElm.scrollTop + listElm.clientHeight + 1 >=
          listElm.scrollHeight
        ) {
          if (!_this.props.isListLoading) {
            if (
              _this.props.total_count !== 1 &&
              _this.props.total_count >= pageSet
            ) {
              pageSet = _this.props.page + 1;
              _this.props.setParamsInUrl("page", pageSet);
              pageSet++;
            }
          }
        }
      });
    }
  }

  handleClick = id => {
    this.refx[id].current.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });
  };

  onChild = id => {
    this.props.onChildClickCallback(id, false);
  };

  handleLoad = val => {
    let { setParamsInUrl, page } = this.props;
    let e = document.getElementsByClassName("cdp")[0];
    page = parseInt(page);

    if (val === "prev") {
      setParamsInUrl("page", page - 1);
      e.setAttribute("actpage", page - 1);
    } else if (val === "next") {
      setParamsInUrl("page", page + 1);
      e.setAttribute("actpage", page + 1);
    } else {
      setParamsInUrl("page", val);
      e.setAttribute("actpage", val);
    }
  };

  render() {
    let { listing, total_count, page, priceCalculation } = this.props;

    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      lazyLoad: "ondemand",
      initOnLoad: true,
      nextSlidesToPreload: 1,
      fade: true
    };

    const pageNumber = [];

    for (let index = 1; index <= total_count; index++) {
      pageNumber.push(
        <span
          className="cdp_i"
          key={index}
          onClick={() => this.handleLoad(index)}
        >
          {index}
        </span>
      );
    }

    return (
      <div id="search_result" className="search_result">
        {listing.map((list, i) => (
          <div
            ref={this.refx[list.id]}
            id={list.id}
            className={`row ${list.show ? "show" : ""}`}
            key={i}
            onMouseEnter={() => this.onChild(list.id)}
            onMouseLeave={() => this.onChild(list.id)}
          >
            <div className="left">
              <a href={list.url}>
                <Slider {...settings}>
                  {list.images.map((image, i) => (
                    <img src={image} data-lazy={image} alt="" key={i} />
                  ))}
                </Slider>
              </a>
            </div>
            <div className="right">
              <div className="top">
                <div className="heading">
                  <h3>
                    <a href={list.url}>{list.title}</a>
                  </h3>

                  <FavAction space_id={list.id} />
                </div>

                <a href={list.url} className="show_4">
                  <p>
                    <i>{list.location.place}</i>
                  </p>

                  <p className="price">
                    <strong>{priceCalculation(list.price)}</strong>{" "}
                    {list.isLongTerms === 1 ? (
                      <span>/{list.long_term}</span>
                    ) : (
                      <span>/{list.space.type === 1 ? "day" : "hour"}</span>
                    )}
                  </p>
                  <p className="upto">
                    Up to {list.space.quantity} {list.space.q_name}{" "}
                    {list.isLongTerms === 1 ? (
                      <span className="long-term">Long Term</span>
                    ) : list.discount ? (
                      <span className="discount">Discount</span>
                    ) : null}
                  </p>
                </a>

                <a href={list.url} className="show_1">
                  <p>
                    <span>Up to </span>
                    <span>
                      {list.space.quantity} {list.space.q_name} |{" "}
                      {list.location.place}
                    </span>
                  </p>
                  {list.isLongTerms === 1 ? (
                    <span className="long-term">Long Term</span>
                  ) : list.discount ? (
                    <div className="discount">
                      <label>Discount</label>
                      <div className="price">
                        {Object.keys(list.discount).map((price, i) => (
                          <span key={i}>
                            {priceCalculation(list.discount[price])}
                            <i> /{price}</i>
                          </span>
                        ))}
                      </div>
                    </div>
                  ) : null}
                </a>
              </div>
              <div className="bottom">
                <span className="rating" />
                <span className="price">
                  {priceCalculation(list.price)}{" "}
                  {list.isLongTerms === 1 ? (
                    <i>/{list.long_term}</i>
                  ) : (
                    <i>/{list.space.type === 1 ? "day" : "hour"}</i>
                  )}
                </span>
              </div>
            </div>
          </div>
        ))}

        <div
          className="content_detail__pagination cdp"
          id="location_pagination"
          actpage={page}
        >
          <i
            className="fa fa-chevron-left cdp_i"
            onClick={() => this.handleLoad("prev")}
          />

          {pageNumber}

          <i
            className="fa fa-chevron-right cdp_i"
            onClick={() => this.handleLoad("next")}
          />
        </div>
      </div>
    );
  }
}

export default SearchPageComp;
